import component from './manageHotels.vue';
export const MANAGE_HOTELS = "manageHotels";

export default{
    id: MANAGE_HOTELS,
    component,
}